'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Select2BaseColumn2 = require('./Select2BaseColumn');

var _Select2BaseColumn3 = _interopRequireDefault(_Select2BaseColumn2);

var _odataUri = require('../../utils/odata-uri');

var _localize = require('../../core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Resx = (0, _localize2.default)('Common');

var BooleanColumn = function (_Select2BaseColumn) {
	_inherits(BooleanColumn, _Select2BaseColumn);

	function BooleanColumn() {
		_classCallCheck(this, BooleanColumn);

		return _possibleConstructorReturn(this, (BooleanColumn.__proto__ || Object.getPrototypeOf(BooleanColumn)).apply(this, arguments));
	}

	_createClass(BooleanColumn, [{
		key: 'displayValue',
		value: function displayValue(value) {
			return value ? Resx.Common.Yes : Resx.Common.No;
		}
	}, {
		key: 'createEditor',
		value: function createEditor(value, id) {
			var inputId = this.column.name() + '_' + id;
			return '<span class="checkbox">\n\t<input id="' + inputId + '" class="table-input" type="checkbox" ' + (value ? 'checked' : '') + ' />\n\t<label for="' + inputId + '"></label>\n</span>';
		}
	}, {
		key: 'getEditorValue',
		value: function getEditorValue(cellElement) {
			return (0, _jquery2.default)(cellElement).find('input.table-input').is(':checked');
		}

		// -------------- FILTERS --------------------

	}, {
		key: 'createFilter',
		value: function createFilter() {
			return '<div class="input-group">\n    <select class="form-control table-filter">\n        <option value="">' + Resx.Common.All + '</option>\n        <option value="true">' + Resx.Common.Yes + '</option>\n        <option value="false">' + Resx.Common.No + '</option>\n    </select>\n</div>';
		}
	}, {
		key: 'buildFilterExpression',
		value: function buildFilterExpression(fieldName, columnFilter) {
			if (columnFilter === 'true' || columnFilter === 'false') {
				return _odataUri.filters.equals(fieldName, columnFilter === 'true');
			} else {
				return null;
			}
		}
	}]);

	return BooleanColumn;
}(_Select2BaseColumn3.default);

exports.default = BooleanColumn;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/BooleanColumn.js
// module id = 487
// module chunks = 0